import {
  getUserContentOfType,
  getUserContentBySearchQuery,
  getFeed,
} from '@/api/content';
import { ContentTypes } from '@/constants/linkContent';

const DEFAULT_REQUESTED_CONTENT_TYPE = ContentTypes.EVERYTHING;

const LIMIT = 4;
const defaultQuery = () => ({
  page: 0,
  limit: LIMIT,
  skip: 0,
  featured: true,
});

const defaultState = () => ({
  loading: false,
  content: [],
  query: defaultQuery(),
  hasMore: true,
  requestedContentType: DEFAULT_REQUESTED_CONTENT_TYPE,
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setContent(state, payload) {
      state.content = state.content.concat(payload);
      if (payload.length < LIMIT) {
        state.hasMore = false;
        state.query.page = 0;
      } else {
        state.query.page += 1;
      }
    },
    setRequestedContentType(state, type) {
      state.requestedContentType = type;
    },
    resetState(state) {
      Object.assign(state, defaultState());
    },
    setQuery(state, query) {
      if (query) {
        state.query = query;
      }
    },
  },
  actions: {
    async get({ commit, dispatch, getters, rootGetters }) {
      try {
        commit('setLoading', true);
        const { id: uid } = rootGetters['community/member'];
        const { requestedContentType, query: { page, limit } } = getters;
        const { data } = await getUserContentOfType(uid, requestedContentType, page, limit);
        commit('setContent', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
    async getNative({ commit, dispatch, getters, rootGetters }) {
      try {
        commit('setLoading', true);
        const { id: uid } = rootGetters['community/member'];
        const { data } = await getFeed(uid, getters.query);
        commit('setQuery', data.query);
        commit('setContent', data.feed);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
    async search({ commit, dispatch, getters, rootGetters }, { query }) {
      try {
        commit('setLoading', true);
        if (!query) return;
        const { id: uid } = rootGetters['community/member'];
        const { requestedContentType, query: { page, limit } } = getters;
        const { data } = await getUserContentBySearchQuery(uid, requestedContentType, query, page, limit);
        commit('setContent', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading && !state.content.length,
    loadMoreLoading: state => state.loading && !!state.content.length,
    content: state => state.content || [],
    query: state => state.query,
    hasMore: state => state.hasMore && !!state.content.length,
    requestedContentType: state => state.requestedContentType,
  },
};
